import { toString as toString_1, Record, Union } from "../fable_modules/fable-library-js.4.17.0/Types.js";
import { obj_type, anonRecord_type, option_type, int32_type, record_type, bool_type, string_type, union_type } from "../fable_modules/fable-library-js.4.17.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { useReact_useEffectOnce_3A5B6456, useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.2.7.0/React.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.17.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { singleton, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.17.0/List.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { some, unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.17.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { createObj, equals, uncurry2 } from "../fable_modules/fable-library-js.4.17.0/Util.js";
import { GenericResponse_$reflection } from "../Shared/ApiDataTypes.js";
import { empty as empty_1, append, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.17.0/Seq.js";
import { Interop_reactApi } from "../fable_modules/Feliz.2.7.0/Interop.fs.js";
import { Button_pillButton } from "../Components/Components.js";

class Rating extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Bad", "Meh", "Good"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "😐" : ((this$.tag === 2) ? "😀" : "🙁");
    }
}

function Rating_$reflection() {
    return union_type("Investfora.PreOpenSummaryFeedback.Rating", [], Rating, () => [[], [], []]);
}

function Rating__ToRatingValue(this$) {
    switch (this$.tag) {
        case 1:
            return 3;
        case 2:
            return 5;
        default:
            return 1;
    }
}

class FeedbackForm extends Record {
    constructor(Rating, Feedback, CommentForm) {
        super();
        this.Rating = Rating;
        this.Feedback = Feedback;
        this.CommentForm = CommentForm;
    }
}

function FeedbackForm_$reflection() {
    return record_type("Investfora.PreOpenSummaryFeedback.FeedbackForm", [], FeedbackForm, () => [["Rating", Rating_$reflection()], ["Feedback", string_type], ["CommentForm", bool_type]]);
}

class SubmitRatingRequest extends Record {
    constructor(Date$, Rating, Feedback) {
        super();
        this.Date = Date$;
        this.Rating = (Rating | 0);
        this.Feedback = Feedback;
    }
}

function SubmitRatingRequest_$reflection() {
    return record_type("Investfora.PreOpenSummaryFeedback.SubmitRatingRequest", [], SubmitRatingRequest, () => [["Date", string_type], ["Rating", int32_type], ["Feedback", option_type(string_type)]]);
}

export function Feedback(feedbackInputProps) {
    let elems_4;
    const preOpenDate = feedbackInputProps.preOpenDate;
    const patternInput = useFeliz_React__React_useState_Static_1505(true);
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(false);
    const setSubmitted = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(undefined);
    const updateFeedbackForm = patternInput_2[1];
    const feedbackForm = patternInput_2[0];
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(anonRecord_type(["Rated", bool_type]), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/pre-open/rated/${preOpenDate}`, properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(anonRecord_type(["Rated", bool_type]), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_3) => {
                const res = _arg_3;
                if (res.tag === 0) {
                    patternInput[1](res.fields[0].Rated);
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    });
    const submitRating = (feedback) => {
        const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((feedback.Rating.tag === 2) ? ((setSubmitted(true), Promise.resolve())) : (Promise.resolve())).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let body_2, decoder_3, data_5, caseStrategy_11, extra_11;
            const txt = (feedback.Feedback.trim().length > 0) ? feedback.Feedback.trim() : undefined;
            const req = new SubmitRatingRequest(preOpenDate, Rating__ToRatingValue(feedback.Rating), txt);
            return ((body_2 = Auto_generateBoxedEncoder_437914C6(SubmitRatingRequest_$reflection(), undefined, undefined, undefined)(req), (decoder_3 = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_5 = some(body_2), (caseStrategy_11 = undefined, (extra_11 = undefined, (() => {
                let properties_6;
                try {
                    const properties_3_1 = Helper_withProperties(singleton(new Types_RequestProperties(3, ["cors"])), (properties_6 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_11, extra_11)(data_1_2))]), properties_6), data_5), properties_6)));
                    const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/pre-open/rating", properties_3_1).then((_arg_4) => {
                        let response_3, decoder_1_2;
                        return ((response_3 = _arg_4, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_11), unwrap(extra_11))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_5) => {
                            let matchValue_2;
                            return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_2), _arg_5), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                    }))));
                    return pr_2.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                }
                catch (exn_1) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                }
            })())))))).then((_arg_6) => {
                if (_arg_6.tag === 0) {
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        })))));
        pr_3.then();
    };
    const ratingButton = (rating) => {
        let ff_1;
        return createElement("button", {
            style: {
                width: 30,
                height: 30,
                borderWidth: 2,
                padding: 10,
                borderColor: (feedbackForm != null) ? (!equals(feedbackForm.Rating, rating) ? ((ff_1 = feedbackForm, "#FFFFFF")) : "#e1e1e1") : "#e1e1e1",
                borderStyle: "solid",
                backgroundColor: "#FFFFFF",
                borderRadius: 50,
                width: 35,
                height: 35,
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                userSelect: "none",
                fontSize: 30 + "px",
            },
            disabled: feedbackForm != null,
            onClick: (_arg_7) => {
                if (feedbackForm == null) {
                    submitRating(new FeedbackForm(rating, "", false));
                    if (rating.tag === 2) {
                    }
                    else {
                        updateFeedbackForm(new FeedbackForm(rating, "", false));
                    }
                }
            },
            children: toString_1(rating),
        });
    };
    return createElement("div", createObj(ofArray([["style", {}], (elems_4 = toList(delay(() => {
        let elems_3;
        return !patternInput[0] ? singleton_1(createElement("div", createObj(ofArray([["style", {
            borderRadius: 10,
            borderWidth: 2,
            backgroundColor: "#FFFFFF",
            borderColor: "#e1e1e1",
            borderRadius: 5,
            padding: ((10 + "px") + " ") + (2 + "vw"),
            gap: 10 + "px ",
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            textAlign: "center",
        }], (elems_3 = toList(delay(() => (!patternInput_1[0] ? append(singleton_1(createElement("span", {
            children: ["Hva synes du om denne \"Før børsåpning\" utgaven?"],
        })), delay(() => {
            let elems;
            return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "row",
                gap: 10 + "px ",
                justifyContent: "center",
            }], (elems = [ratingButton(new Rating(0, [])), ratingButton(new Rating(1, [])), ratingButton(new Rating(2, []))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let elems_1;
                const matchValue_3 = feedbackForm;
                if (matchValue_3 != null) {
                    const ff_2 = matchValue_3;
                    return append(singleton_1(createElement("div", createObj(ofArray([["style", {}], (elems_1 = [createElement("textarea", {
                        rows: 5,
                        onChange: (ev) => {
                            updateFeedbackForm(new FeedbackForm(ff_2.Rating, ev.target.value, ff_2.CommentForm));
                        },
                        defaultValue: ff_2.Feedback,
                        placeholder: "Kommentar (valgfritt)",
                        style: {
                            borderRadius: 7,
                            border: (((1 + "px ") + "solid") + " ") + "var(--text-main)",
                            width: 100 + "%",
                        },
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                        let elems_2;
                        return singleton_1(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            justifyContent: "flex-end",
                        }], (elems_2 = [Button_pillButton("Send", (_arg_8) => {
                            const feedback_1 = ff_2;
                            const pr_4 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                                setSubmitted(true);
                                if (feedback_1.Feedback.trim().length > 0) {
                                    submitRating(feedback_1);
                                    return Promise.resolve();
                                }
                                else {
                                    return Promise.resolve();
                                }
                            }));
                            pr_4.then();
                        }, empty())], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))));
                    }));
                }
                else {
                    return empty_1();
                }
            }));
        })) : singleton_1(createElement("span", {
            children: ["Takk for tilbakemeldingen!"],
        }))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))) : empty_1();
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
}

